import {
    Dispatch,
    RefObject,
    SetStateAction,
    useReducer,
    useState,
} from 'react'
import { Link } from 'react-router-dom'

import { addNLUExample } from '../../../api/nluData'
import { ReactComponent as LinkIcon } from '../../../assets/icons/link.svg'
import { ReactComponent as AddIcon } from '../../../assets/icons/plus.svg'
import { ReactComponent as TrashIcon } from '../../../assets/icons/trash.svg'
import { useMessagesStore } from '../../../stores/messages'
import { IEntity } from '../../../stores/nluDataStore'
import { IMessage } from '../../../types/messages'
import MessageSection from '../../NLUData/NLUDataExample/EntitySection/MessageSection/MessageSection'

import messageDropdownReducer, {
    MessageDropdownActions,
} from './messageDropdownReducer'

import { joinClassNames } from '../../../utils/styles'
import styles from './message.module.scss'

interface IMessageProps {
    message: IMessage
    messagesRef: RefObject<HTMLDivElement>
    isAnyEntityEditing: boolean
    setIsAnyEntityEditing: Dispatch<SetStateAction<boolean>>
}

function Message(props: IMessageProps) {
    const { messagesRef, isAnyEntityEditing, setIsAnyEntityEditing } = props

    const [{ tabs, intents, entities: allEntities }] = useMessagesStore()

    const [defaultTab] = tabs

    const [tab, setTab] = useState<string>(defaultTab)
    const [{ message }, dispatch] = useReducer(messageDropdownReducer, {
        message: props.message,
    })
    const { intent, message_validated, intent_confidence, conversation_id } =
        message

    const [, { setMessageValidated }] = useMessagesStore()

    const handleValidate = async () => {
        await setMessageValidated(message._id)
    }

    const handleAddNLU = async () => {
        await addNLUExample(tab, message)

        await handleValidate()
    }

    return (
        <>
            <tr className={styles.message}>
                <td
                    className={joinClassNames(
                        styles.message__td,
                        styles.message__confidence
                    )}
                >
                    {Math.round(intent_confidence * 100)}%
                </td>
                <td className={styles.message__td}>
                    <div className={styles.message__tab}>
                        <select
                            value={tab}
                            onChange={(e) => setTab(e.target.value)}
                            className={styles.message__select}
                        >
                            {tabs?.map((tab) => (
                                <option key={tab} value={tab}>
                                    {tab}
                                </option>
                            ))}
                        </select>
                    </div>
                </td>
                <td className={styles.message__td}>
                    <div className={styles.message__intent}>
                        <input
                            list="intent"
                            name="intent"
                            value={intent}
                            onChange={(e) =>
                                dispatch({
                                    type: MessageDropdownActions.SET_INTENT,
                                    payload: e.target.value,
                                })
                            }
                            className={styles.message__input}
                        />
                        <datalist id="intent">
                            {intents.map((intent) => (
                                <option key={intent.name} value={intent.name}>
                                    {intent.name}
                                </option>
                            ))}
                        </datalist>
                    </div>
                </td>
                <td className={styles.message__td}>
                    <MessageSection
                        examplesRef={messagesRef}
                        example={message}
                        allEntities={allEntities}
                        setEntities={(entities: IEntity[]) =>
                            dispatch({
                                type: MessageDropdownActions.SET_ENTITY,
                                payload: entities,
                            })
                        }
                        className={styles.message__messageSection}
                        isAnyEntityEditing={isAnyEntityEditing}
                        setIsAnyEntityEditing={setIsAnyEntityEditing}
                    />
                </td>
                <td className={styles.message__td}>
                    <div className={styles.message__buttons}>
                        <button
                            onClick={handleAddNLU}
                            className={styles.message__addBtn}
                        >
                            <AddIcon className={styles.message__btnIcon} />
                        </button>
                        <Link
                            to={`/conversations/${conversation_id}`}
                            className={styles.message__link}
                        >
                            <LinkIcon className={styles.message__icon} />
                        </Link>
                        <button
                            onClick={handleValidate}
                            className={joinClassNames(
                                styles.message__deleteBtn,
                                message_validated &&
                                    styles.message__validateBtnValidated
                            )}
                        >
                            <TrashIcon className={styles.message__icon} />
                        </button>
                    </div>
                </td>
            </tr>
        </>
    )
}

export default Message
